import httpClient from "./httpClient";

const prefix = "/candidates";

export async function updateSalary(id: number, data: {}) {
  return (await httpClient.put(`${prefix}/update-salary/${id}`, data)).data;
}

export async function getMissingIMSSSalary() {
  return (await httpClient.get(`${prefix}/missing-IMSS-salary`)).data;
}

export async function getStatsChilitos() {
  return (await httpClient.get(`${prefix}/stats`)).data;
}

export async function getChilitosByBranch(id: number) {
  return (await httpClient.get(`${prefix}/documents-branch/${id}`)).data;
}

/** Documentos pendientes con la misma lógica que check-my-proceeding (app / QR). */
export async function getChilitosByBranchAccurate(id: number) {
  return (
    await httpClient.get(`${prefix}/documents-branch-accurate/${id}`)
  ).data;
}

export async function getDocumentsStatistics() {
  return (await httpClient.get(`${prefix}/documents-statistics`)).data;
}

export async function getShiftManager() {
  return (await httpClient.get(`${prefix}/get-shift-manager`)).data;
}

export async function getFilesByProceeding(proceedingId: number) {
  return (
    await httpClient.get(`/proceedings/get-files-by-proceeding/${proceedingId}`)
  ).data;
}

export async function getAllRecruitmentDatesByPartner(partnerId: number) {
  return (await httpClient.get(`${prefix}/all-recruitment-dates/${partnerId}`))
    .data;
}

export async function updateCandidate(id: number, data: any) {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}
